import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-785bb576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-country form-item-cell" }
const _hoisted_2 = { class: "form-item-label is-required" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收件国家/地区", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryPicker = _resolveComponent("CountryPicker")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", {
        class: "title-en",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPicker && _ctx.showPicker(...args)))
      }, " Country/Region ")
    ]),
    (_ctx.displayCountryInfo)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "form-item-checkbox g-input",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPicker && _ctx.showPicker(...args)))
        }, _toDisplayString(_ctx.displayCountryInfo.name) + " " + _toDisplayString(_ctx.displayCountryInfo.nameCn), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_CountryPicker, {
      modelValue: _ctx.form.country,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.country) = $event)),
      "is-show-picker": _ctx.isShowPicker,
      onCancel: _ctx.onClosePicker
    }, null, 8, ["modelValue", "is-show-picker", "onCancel"])
  ]))
}